import { SECTION_HOMEPAGE, SECTION_CATEGORY } from '../constants/sections';
import { POST_TITLE_COLOR, POST_TITLE_FONT, POST_TEXT_COLOR, POST_PAGE_FONT, BUTTON_COLOR, BUTTON_TEXT_COLOR, } from '../constants/wix-params';
import { getSiteColor, setColorOpacity } from './colors';
import { getSiteFont } from './fonts';
const DEFAULT = 'default';
const wixParamMap = {
    [DEFAULT]: {
        titleColor: POST_TITLE_COLOR,
        titleFont: POST_TITLE_FONT,
        textColor: POST_TEXT_COLOR,
        textFont: POST_PAGE_FONT,
    },
    [SECTION_HOMEPAGE]: {
        titleColor: 'post-homepage-titleColor',
        titleFont: 'post-full-homepage-titleFont',
        textColor: 'post-homepage-descriptionColor',
        textFont: 'post-full-homepage-descriptionFont',
    },
    [SECTION_CATEGORY]: {
        titleColor: 'post-category-titleColor',
        titleFont: 'post-full-category-titleFont',
        textColor: 'post-category-descriptionColor',
        textFont: 'post-full-category-descriptionFont',
    },
};
export const getBannerStyle = ({ appSettings, section = DEFAULT }) => {
    const wixParams = wixParamMap[section];
    const titleColor = getSiteColor(appSettings, {
        wixParam: wixParams.titleColor,
        presetFallback: 'color-5',
        colorFallback: '#2f2e2e',
    });
    const titleFont = getSiteFont(appSettings, {
        wixParam: wixParams.titleFont,
        presetFallback: 'Body-M',
        fontFallback: "'open sans',sans-serif",
        onlyFamily: true,
    });
    const textColor = getSiteColor(appSettings, {
        wixParam: wixParams.textColor,
        presetFallback: 'color-5',
        colorFallback: '#000',
    });
    const textFont = getSiteFont(appSettings, {
        wixParam: wixParams.textFont,
        presetFallback: 'Body-M',
        fontFallback: "'open sans',sans-serif",
        onlyFamily: true,
    });
    const borderColor = setColorOpacity(textColor, 0.2);
    const buttonColor = getSiteColor(appSettings, {
        wixParam: BUTTON_COLOR,
        presetFallback: 'color-8',
        colorFallback: '#3899ec',
    });
    const buttonTextColor = getSiteColor(appSettings, {
        wixParam: BUTTON_TEXT_COLOR,
        presetFallback: 'color-1',
        colorFallback: '#fff',
    });
    return {
        '--paywall-title-color': titleColor,
        '--paywall-title-font': titleFont,
        '--paywall-text-color': textColor,
        '--paywall-text-font': textFont,
        '--paywall-button-color': buttonColor,
        '--paywall-button-text-color': buttonTextColor,
        '--paywall-border-color': borderColor,
    };
};
//# sourceMappingURL=paywall-theme.js.map